(function() {
    'use strict';

    /**
     * ApplicationsController - contrôleur pour la page des applications mobiles
     */
    angular
        .module('observatoireApp')
        .controller('ApplicationsController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {
            
            // Données des applications
            $scope.applications = [
                {
                    id: 'otfip',
                    name: 'Application mobile OTFIP',
                    logo: 'assets/images/logo-app-otfip.png',
                    description: "L\'application mobile officielle de l\'Observatoire Tchadien des Finances Publiques vous permet d\'accéder à toutes les données financières publiques du Tchad directement depuis votre smartphone.",
                    features: [
                        'Consultation des données du budget national',
                        'Visualisation des publications et rapports récents',
                        'Accès aux informations sur les finances publiques',
                        'Notifications des nouvelles publications',
                        'Partage facile des données et documents'
                    ],
                    downloads: {
                        ios: 'https://apps.apple.com/us/app/otfip/id6480483093?l=fr-FR',
                        android: 'https://play.google.com/store/apps/details?id=com.brainit.otfip&pcampaignid=web_share'
                    }
                },
                {
                    id: 'eagent',
                    name: 'E-Agent',
                    logo: 'assets/images/logo-app-eagent.png',
                    description: "E-Agent est une application mobile dédiée aux agents de l\'État permettant un suivi simplifié des procédures administratives et un accès privilégié aux données financières.",
                    features: [
                        'Suivi des dossiers administratifs',
                        'Accès sécurisé aux documents officiels',
                        'Tableau de bord personnalisé',
                        'Système de notifications pour les mises à jour importantes',
                        'Collaboration facilitée entre les différents services'
                    ],
                    downloads: {
                        ios: '#',
                        android: '#'
                    }
                },
                {
                    id: 'cgi',
                    name: 'CGI',
                    logo: 'assets/images/logo-app-cgi.png',
                    description: "L\'application CGI (Contrôle de Gestion Intégré) permet de suivre et gérer les processus budgétaires et financiers de manière centralisée avec un accent sur la transparence et la traçabilité.",
                    features: [
                        'Suivi en temps réel des dépenses publiques',
                        'Génération de rapports financiers détaillés',
                        'Outils d\'analyse pour l\'optimisation des ressources',
                        'Système d\'alerte pour les écarts budgétaires',
                        'Interface avec d\'autres systèmes de gestion financière'
                    ],
                    downloads: {
                        ios: '#',
                        android: '#'
                    }
                }
            ];
            
            // Initialiser le comportement de l\'accordéon après le chargement de la page
            $timeout(function() {
                // Animation pour la rotation des flèches lors du clic
                $('.card-header').on('click', function() {
                    $(this).find('.fa-chevron-down').toggleClass('rotate-icon');
                });
                
                // Ajouter la classe CSS pour la rotation
                $('.collapse.show').prev('.card-header').find('.fa-chevron-down').addClass('rotate-icon');
                
                // Gérer le clic sur l'accordéon
                $('#applicationsAccordion').on('shown.bs.collapse', function(e) {
                    $(e.target).prev('.card-header').find('.fa-chevron-down').addClass('rotate-icon');
                }).on('hidden.bs.collapse', function(e) {
                    $(e.target).prev('.card-header').find('.fa-chevron-down').removeClass('rotate-icon');
                });
            }, 100);
            
            // Fonction pour ouvrir un app store
            $scope.openAppStore = function(url) {
                if (url && url !== '#') {
                    window.open(url, '_blank');
                }
            };
        }]);

})();
